import React from 'react';

const TestTailwind = () => {
  return (
    <div className="p-8">
      <h1 className="text-3xl font-bold text-blue-600 mb-4">Tailwind CSS Test</h1>
      <div className="bg-gray-100 p-6 rounded-lg shadow-md">
        <p className="text-gray-800 mb-2">Đây là một đoạn text để kiểm tra Tailwind CSS</p>
        <button className="bg-green-500 hover:bg-green-600 text-white font-bold py-2 px-4 rounded">
          Test Button
        </button>
      </div>
    </div>
  );
};

export default TestTailwind; 